import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NdmsSafeSubscriber } from 'projects/shared/core/interfaces/ndms-safe-subscriber';
import { ToastService } from 'projects/shared/core/services/toast.service';
import { UserGuideModel } from 'projects/rms/app/api/models/user-guide-model';
import { UserGuideService } from 'projects/rms/app/api/services/user-guide.service';
import { FindFilter } from 'projects/rms/app/api/models/find-filter';

@Injectable()
export class RmsUserGuideService extends NdmsSafeSubscriber {
  baseUrl: string;
  userGuides: string;

  constructor(
    @Inject('BASE_URL') baseUrl: string,
    @Inject('USER_GUIDES') userGuides: string,
    private _http: HttpClient,
    private _toastService: ToastService,
    private _userGuideService: UserGuideService) {
    super();
    this.baseUrl = baseUrl;
    this.userGuides = userGuides;
  }

  downloadUserGuide(categoryId: number) {
    return new Promise<void>((resolve, reject) => {
      let url = `${this.baseUrl}/view/rms/admin/UserGuide/DownloadUserGuide/${categoryId}`;
      this.safeSubscribe(this._http.get(url, { responseType: 'blob', observe: 'response' }), response => {
        if (response.body.size === 0) {
          return this._toastService.showError("User guide not found in repository.");
        }
        else {
          let fileData = new File([response.body], response.headers.get('x-fileName'), { type: response.headers.get('content-type') });
          let guideUrl = URL.createObjectURL(fileData);
          window.open(guideUrl, "_blank", "popup=false,location=no,titlebar=no,status=no");
          URL.revokeObjectURL(guideUrl);
        }
      }, error => {
        if (error.status === 500) {
          this._toastService.showError("User guide not found in repository or is inactive.");
        }
        else {
          this._toastService.showError(error.status.toString() + " " + error.statusText);
        }
      });
    })
  }

  getUserGuides() {
    return new Promise<UserGuideModel[]>((resolve, reject) => {
      let filter: FindFilter = {
        findKeys: {
          "Active": "true"
        },
        includes: ["Category"],
        pagingInfo: {
          pageNumber: 0,
          pageSize: 100
        }
      };
      this.safeSubscribe(this._userGuideService.FindInDomain(filter), data => {
        resolve(data);
      }, error => {
        this._toastService.showError(error);
        reject();
      });
    });
  }
  
}